import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { DeliveryService } from '../Services/DeliveryService';
import PropTypes from 'prop-types';
import { Grid, LinearProgress, Typography, TextField, Button, Fade, Dialog } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    sectionHeading: {
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightMedium,
    },
    heading: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightMedium,
    },
    subheading: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightRegular,
        textAlign: "left"
    },
    subheadingLink: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightRegular,
        textAlign: "left",
        color: "blue",
        textDecoration: "underline",
        cursor: "pointer"
    }
}));

const DialogTitle = (props => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });
  
  const DialogContent = withStyles(theme => ({
    root: {
      padding: theme.spacing(2),
    },
  }))(MuiDialogContent);
  
  const DialogActions = withStyles(theme => ({
    root: {
      margin: 0,
      padding: theme.spacing(1),
    },
  }))(MuiDialogActions);

export default function UpdateGRN(props){
    const { title, transaction_id, invoice_no} = props;
    const [open, setOpen] = React.useState(transaction_id ? true : false);
    const [loading, setLoading] = React.useState(false);
    const [grn, setGRN] = React.useState('');

    React.useEffect(() =>{
        if(props.grn){
            setGRN(props.grn);
        }
    }, [props.grn])
  
    const classes = useStyles();
  
    const handleSave = () => {
        if(grn && grn.length > 0){
            setLoading(true);
            DeliveryService.updateGRN(transaction_id, grn)
            .then(() => {
                setLoading(false);
                handleClose(true);
                props.showSnackBar(`Updated the GRN for invoice ${invoice_no}`, 'success');
            })
            .catch(() => {
                setLoading(false);
                props.showSnackBar('Something went wrong. Please try again.', 'error');
            });
        }
    }

    React.useEffect(() => {
        setOpen(props.open)
        return () => {
            setGRN('');
        }
    }, [transaction_id && props.open]);
  
   
    const handleClose = (update = false) => {
      props.close(update);
      setGRN('');
      setOpen(false);
    };
  
    return (
        <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} fullWidth maxWidth="sm">
          <DialogTitle id="customized-dialog-title" onClose={handleClose} classes={classes}>
            {title}
          </DialogTitle>
          <DialogContent dividers>
              <Grid container justify="flex-start" alignItems="center" direction="row">
                  <Grid item xs={12} lg={12}>
                      <Fade
                          in={loading}
                          style={{
                              transitionDelay: loading ? '10ms' : '0ms'
                          }}
                          unmountOnExit
                          >
                          <LinearProgress style={{height: 5, width: "100%"}} color="secondary"/>
                      </Fade>
                  </Grid>
                  <Grid item container xs={12} lg={12} key={"header"} spacing={2}  alignItems="center">
                      <Grid item xs={6} lg={6}>
                          <Typography className={classes.heading} style={{textAlign: 'left'}}>Invoice No</Typography>
                      </Grid>
                      <Grid item xs={6} lg={6}>
                          <Typography className={classes.heading} style={{textAlign: 'left'}}>{invoice_no}</Typography>
                      </Grid>
                      <Grid item xs={6} lg={12}>
                        <TextField
                            id="outlined-helperText"
                            label="GRN"
                            value={grn}
                            fullWidth
                            margin="dense"
                            onChange={(e) => setGRN(e.target.value)}
                            helperText="Please provide the GRN no provided by store"
                            variant="outlined"
                        />
                      </Grid>
                  </Grid>
              </Grid>
              </DialogContent>
              <DialogActions>
                  <Button autoFocus onClick={handleClose} color="secondary">
                      Close
                  </Button>
                  <Button autoFocus onClick={handleSave} color="primary">
                      Save
                  </Button>
              </DialogActions>
        </Dialog>
    );
}

UpdateGRN.prototype = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    close: PropTypes.func.isRequired,
    content: PropTypes.any.isRequired,
    maxWidth: PropTypes.any,
    fullWidth: PropTypes.bool
};